import { render } from "./banner.vue?vue&type=template&id=ad84b7ec&scoped=true&ts=true"
import script from "./banner.vue?vue&type=script&lang=ts"
export * from "./banner.vue?vue&type=script&lang=ts"

import "./banner.vue?vue&type=style&index=0&id=ad84b7ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad84b7ec"]])

export default __exports__